const schema = {
    "Documento": {
        "type": "object",
        "description": "Informacion Tributaria del DTE",
        /* "ID": {
            "type": "string"
        }, */
        "Encabezado": {
            "type": "object",
            "description": "Identificacion y Totales del Documento",
            "IdDoc": {
                "type": "object",
                "description": "Identificacion del DTE",
                "TipoDTE": {
                    "type": "integer",
                    "description": "Tipo de DTE - Tipos de Documentos Tributarios Electronicos",
                    "enum": [
                        33,
                        34,
                        39,
                        41,
                        46,
                        52,
                        56,
                        61
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "Folio": {
                    "type": "integer",
                    "description": "Folio del Documento Electronico - Folio de DTE - 10 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "FchEmis": {
                    "type": "string",
                    "description": "Fecha Emision Contable del DTE (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                },
                "IndNoRebaja": {
                    "type": "integer",
                    "description": "Nota de Credito sin Derecho a Descontar Debito",
                    "enum": [
                        1
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "TipoDespacho": {
                    "type": "integer",
                    "description": "Indica Modo de Despacho de los Bienes que Acompanan al DTE",
                    "enum": [
                        1,
                        2,
                        3
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "IndTraslado": {
                    "type": "integer",
                    "description": "Incluido en Guias de Despacho para Especifiicar el Tipo de Traslado de Productos",
                    "enum": [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "TpoImpresion": {
                    "type": "string",
                    "description": "Tipo de impresión N (Normal) o T (Ticket)",
                    "enum": [
                        "N",
                        "T"
                    ],
                    "maxLength": 1,
                    "minLength": 1
                },
                "IndServicio": {
                    "type": "integer",
                    "description": "Indica si Transaccion Corresponde a la Prestacion de un Servicio",
                    "enum": [
                        1,
                        2,
                        3
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "MntBruto": {
                    "type": "integer",
                    "description": "Indica el Uso de Montos Brutos en Detalle",
                    "enum": [
                        1
                    ]
                },
                "TpoTranCompra": {
                    "type": "integer",
                    "description": "Tipo de Transacción para el comprador\nIndica el Uso de Montos Brutos en Detalle - Tipo de Transacción para el comprador",
                    "enum": [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "TpoTranVenta": {
                    "type": "integer",
                    "description": "Tipo de Transacción para el vendedor\nIndica el Uso de Montos Brutos en Detalle - Tipo de Transacción para el vendedor",
                    "enum": [
                        1,
                        2,
                        3,
                        4
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "FmaPago": {
                    "type": "integer",
                    "description": "Forma de Pago del DTE",
                    "enum": [
                        1,
                        2,
                        3
                    ],
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "FmaPagExp": {
                    "type": "integer",
                    "description": "Forma de Pago Exportación Tabla Formas de Pago de Aduanas",
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "FchCancel": {
                    "type": "string",
                    "description": "Fecha de Cancelacion del DTE (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                },
                "MntCancel": {
                    "type": "integer",
                    "description": "Monto Cancelado al emitirse el documento - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "SaldoInsol": {
                    "type": "integer",
                    "description": "Saldo Insoluto al emitirse el documento - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "MntPagos": {
                    "type": "array",
                    "maxItems": 30,
                    "FchPago": {
                        "type": "string",
                        "description": "Fecha de Pago (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                    },
                    "MntPago": {
                        "type": "integer",
                        "description": "Monto de Pago - Monto de 18 digitos",
                        "minimum": 0,
                        "exclusiveMinimum": false
                    },
                    "GlosaPagos": {
                        "type": "string",
                        "maxLength": 40
                    }
                },
                "PeriodoDesde": {
                    "type": "string",
                    "description": "Periodo de Facturacion - Desde (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                },
                "PeriodoHasta": {
                    "type": "string",
                    "description": "Periodo Facturacion - Hasta (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                },
                "MedioPago": {
                    "type": "string",
                    "description": "Medio de Pago - Medios de Pago",
                    "enum": [
                        "CH",
                        "LT",
                        "EF",
                        "PE",
                        "TC",
                        "CF",
                        "OT"
                    ]
                },
                "TpoCtaPago": {
                    "type": "string",
                    "description": "Tipo Cuenta de Pago",
                    "enum": [
                        "AHORRO",
                        "CORRIENTE",
                        "VISTA"
                    ],
                    "maxLength": 10,
                    "minLength": 5
                },
                "NumCtaPago": {
                    "type": "string",
                    "description": "Número de la cuenta del pago",
                    "maxLength": 20
                },
                "BcoPago": {
                    "type": "string",
                    "description": "Banco donde se realiza el pago",
                    "maxLength": 40
                },
                "TermPagoCdg": {
                    "type": "string",
                    "description": "Codigo del Termino de Pago Acordado",
                    "maxLength": 4
                },
                "TermPagoGlosa": {
                    "type": "string",
                    "description": "Términos del Pago - glosa",
                    "maxLength": 100
                },
                "TermPagoDias": {
                    "type": "integer",
                    "description": "Dias de Acuerdo al Codigo de Termino de Pago",
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "FchVenc": {
                    "type": "string",
                    "description": "Fecha de Vencimiento del Pago (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                },
                "Usuario": {
                    "type": "string",
                    "description": "Nombre de Usuario que creó el DTE",
                },
                "Estado": {
                    "type": "string",
                    "description": "Estado del Documento en el SII",
                    "enum": [
                        "Aceptado",
                        "Con Reparos",
                        "Enviado",
                        "Externo",
                        "Guardado",
                        "Rechazado",
                        "Recibido"
                    ]
                },
                "Evento": {
                    "type": "string",
                    "description": "Respuesta Comercial realizada en el DTE - Código de largo 3",
                    "enum": [
                        "ACD",
                        "AUT",
                        "CED",
                        "ENC",
                        "ERG",
                        "ERM",
                        "NCA",
                        "PAG",
                        "RCD",
                        "RFP",
                        "RFT"
                    ]
                },
                "IdDte": {
                    "type": "integer",
                    "description": "Número interno asignado por el sistema",
                }
            },
            "Emisor": {
                "type": "object",
                "description": "Datos del Emisor",
                "RUTEmisor": {
                    "type": "string",
                    "description": "RUT del Emisor del DTE - Rol Unico Tributario (99..99-X)",
                    "maxLength": 10,
                    "minLength": 3,
                    "pattern": "[0-9]+-([0-9]|K)"
                },
                "RznSoc": {
                    "type": "string",
                    "description": "Nombre o Razon Social del Emisor - Razón Social (max 100)",
                    "maxLength": 100
                },
                "GiroEmis": {
                    "type": "string",
                    "description": "Giro Comercial del Emisor Relevante para el DTE",
                    "maxLength": 80,
                    "minLength": 1
                },
                "Telefono": {
                    "description": "Telefono Emisor - Fono",
                    "type": "string",
                    "maxLength": 40
                },
                "CorreoEmisor": {
                    "type": "string",
                    "description": "Correo Elect. de contacto en empresa del receptor - Dirección email",
                    "maxLength": 80
                },
                "Acteco": {
                    "type": "integer",
                    "description": "Codigo de Actividad Economica del Emisor Relevante para el DTE",
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "GuiaExport": {
                    "type": "object",
                    "description": "Emisor de una Guía de despacho para Exportación",
                    "CdgTraslado": {
                        "type": "integer",
                        "description": "Código Emisor Traslado Excepcional",
                        "enum": [
                            1,
                            2,
                            3,
                            4
                        ],
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "FolioAut": {
                        "type": "integer",
                        "description": "Folio Autorización ( N° de Resolución del SI) - Número de Resolución",
                        "minimum": 0,
                        "exclusiveMinimum": false
                    },
                    "FchAut": {
                        "type": "string",
                        "description": "Fecha de emisión de la Resolución de autorización (AAAA-MM-DD) - Fecha entre 2000-01-01 y 2050-12-31"
                    }
                },
                "Sucursal": {
                    "type": "string",
                    "description": "Sucursal que Emite el DTE",
                    "maxLength": 20
                },
                "CdgSIISucur": {
                    "type": "integer",
                    "description": "Codigo de Sucursal Entregado por el SII",
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "DirOrigen": {
                    "type": "string",
                    "description": "Direccion de Origen",
                    "maxLength": 70
                },
                "CmnaOrigen": {
                    "type": "string",
                    "description": "Comuna de Origen - Comuna",
                    "maxLength": 20
                },
                "CiudadOrigen": {
                    "type": "string",
                    "description": "Ciudad de Origen - Ciudad",
                    "maxLength": 20
                },
                "CdgVendedor": {
                    "type": "string",
                    "description": "Codigo del Vendedor",
                    "maxLength": 60
                },
                "IdAdicEmisor": {
                    "type": "string",
                    "description": "Identificador Adicional del Emisor",
                    "maxLength": 20,
                    "minLength": 1
                }
            },
            "RUTMandante": {
                "type": "string",
                "description": "RUT a Cuenta de Quien se Emite el DTE - Rol Unico Tributario (99..99-X)",
                "maxLength": 10,
                "minLength": 3,
                "pattern": "[0-9]+-([0-9]|K)"
            },
            "Receptor": {
                "type": "object",
                "description": "Datos del Receptor",
                "RUTRecep": {
                    "type": "string",
                    "description": "RUT del Receptor del DTE - Rol Unico Tributario (99..99-X)",
                    "maxLength": 10,
                    "minLength": 3,
                    "pattern": "[0-9]+-([0-9]|K)"
                },
                "CdgIntRecep": {
                    "type": "string",
                    "description": "Codigo Interno del Receptor",
                    "maxLength": 20
                },
                "RznSocRecep": {
                    "type": "string",
                    "description": "Nombre o Razon Social del Receptor - Razón Social (max 100)",
                    "maxLength": 100
                },
                "Extranjero": {
                    "type": "object",
                    "description": "Receptor Extranjero",
                    "NumId": {
                        "type": "string",
                        "description": "Num. Identif. Receptor Extranjero",
                        "maxLength": 20,
                        "minLength": 1
                    },
                    "Nacionalidad": {
                        "type": "string",
                        "description": "Nacionalidad Receptor Extranjero",
                        "maxLength": 3,
                        "minLength": 1
                    }
                },
                "GiroRecep": {
                    "type": "string",
                    "description": "Giro Comercial del Receptor",
                    "maxLength": 40
                },
                "Contacto": {
                    "type": "string",
                    "description": "Telefono o E-mail de Contacto del Receptor",
                    "maxLength": 80
                },
                "CorreoRecep": {
                    "type": "string",
                    "description": "Correo Elect. de contacto en empresa del receptor - Dirección email",
                    "maxLength": 80
                },
                "DirRecep": {
                    "type": "string",
                    "description": "Direccion en la Cual se Envian los Productos o se Prestan los Servicios",
                    "maxLength": 70
                },
                "CmnaRecep": {
                    "type": "string",
                    "description": "Comuna de Recepcion - Comuna",
                    "maxLength": 20
                },
                "CiudadRecep": {
                    "type": "string",
                    "description": "Ciudad de Recepcion - Ciudad",
                    "maxLength": 20
                },
                "DirPostal": {
                    "type": "string",
                    "description": "Direccion Postal",
                    "maxLength": 70
                },
                "CmnaPostal": {
                    "type": "string",
                    "description": "Comuna Postal - Comuna",
                    "maxLength": 20
                },
                "CiudadPostal": {
                    "type": "string",
                    "description": "Ciudad Postal - Ciudad",
                    "maxLength": 20
                }
            },
            "RUTSolicita": {
                "type": "string",
                "description": "RUT que solicita el DTE en Venta a Publico - Rol Unico Tributario (99..99-X)",
                "maxLength": 10,
                "minLength": 3,
                "pattern": "[0-9]+-([0-9]|K)"
            },
            "Transporte": {
                "type": "object",
                "description": "Informacion de Transporte de Mercaderias",
                "Patente": {
                    "type": "string",
                    "description": "Patente del Vehiculo que Transporta los Bienes",
                    "maxLength": 8
                },
                "RUTTrans": {
                    "type": "string",
                    "description": "RUT del Transportista - Rol Unico Tributario (99..99-X)",
                    "maxLength": 10,
                    "minLength": 3,
                    "pattern": "[0-9]+-([0-9]|K)"
                },
                "Chofer": {
                    "type": "object",
                    "RUTChofer": {
                        "type": "string",
                        "description": "RUT del Chofer - Rol Unico Tributario (99..99-X)",
                        "maxLength": 10,
                        "minLength": 3,
                        "pattern": "[0-9]+-([0-9]|K)"
                    },
                    "NombreChofer": {
                        "type": "string",
                        "description": "Nombre del Chofer",
                        "maxLength": 30
                    }
                },
                "DirDest": {
                    "type": "string",
                    "description": "Direccion de Destino",
                    "maxLength": 70
                },
                "CmnaDest": {
                    "type": "string",
                    "description": "Comuna de Destino - Comuna",
                    "maxLength": 20
                },
                "CiudadDest": {
                    "type": "string",
                    "description": "Ciudad de Destino - Ciudad",
                    "maxLength": 20
                },
                "Aduana": {
                    "type": "object",
                    "description": "documentos de Exportación y guías de despacho",
                    "CodModVenta": {
                        "type": "integer",
                        "description": "Código según tabla \"Modalidad de Venta\" de aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "CodClauVenta": {
                        "type": "integer",
                        "description": "Código según Tabla \"Cláusula compra-venta\" de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "TotClauVenta": {
                        "type": "number",
                        "description": "Total Cláusula de venta - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                        "maximum": 1000000000000000000,
                        "minimum": 1,
                        "exclusiveMinimum": false,
                        "exclusiveMaximum": false
                    },
                    "CodViaTransp": {
                        "type": "integer",
                        "description": "Indicar el Código de la vía de transporte utilizada para transportar la mercadería, según tabla Vías de Transporte de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "NombreTransp": {
                        "type": "string",
                        "description": "Nombre o Identificación del Medio de Transporte",
                        "maxLength": 40
                    },
                    "RUTCiaTransp": {
                        "type": "string",
                        "description": "Rut Cía. Transportadora - Rol Unico Tributario (99..99-X)",
                        "maxLength": 10,
                        "minLength": 3,
                        "pattern": "[0-9]+-([0-9]|K)"
                    },
                    "NomCiaTransp": {
                        "type": "string",
                        "description": "Nombre Cía. Transportadora",
                        "maxLength": 40
                    },
                    "IdAdicTransp": {
                        "type": "string",
                        "description": "Identificador Adicional Cía. Transportadora",
                        "maxLength": 20,
                        "minLength": 1
                    },
                    "Booking": {
                        "type": "string",
                        "description": "Numero de reserva del Operador",
                        "maxLength": 20,
                        "minLength": 1
                    },
                    "Operador": {
                        "type": "string",
                        "description": "Código del Operador",
                        "maxLength": 20,
                        "minLength": 1
                    },
                    "CodPtoEmbarque": {
                        "type": "integer",
                        "description": "Código del puerto de embarque según tabla de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "IdAdicPtoEmb": {
                        "type": "string",
                        "description": "Identificador Adicional Puerto de Embarque",
                        "maxLength": 20,
                        "minLength": 1
                    },
                    "CodPtoDesemb": {
                        "type": "integer",
                        "description": "Código del puerto de desembarque según tabla de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "IdAdicPtoDesemb": {
                        "type": "string",
                        "description": "Identificador Adicional Puerto de Desembarque",
                        "maxLength": 20,
                        "minLength": 1
                    },
                    "Tara": {
                        "type": "integer",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "CodUnidMedTara": {
                        "type": "integer",
                        "description": "Código de la unidad de medida según tabla de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "PesoBruto": {
                        "type": "number",
                        "description": "Sumatoria de los pesos brutos de todos los ítems del documento"
                    },
                    "CodUnidPesoBruto": {
                        "type": "integer",
                        "description": "Código de la unidad de medida según tabla de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "PesoNeto": {
                        "type": "number",
                        "description": "Sumatoria de los pesos netos de todos los ítems del documento"
                    },
                    "CodUnidPesoNeto": {
                        "type": "integer",
                        "description": "Código de la unidad de medida según tabla de Aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "TotItems": {
                        "type": "integer",
                        "description": "Indique el total de items del documento",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "TotBultos": {
                        "type": "integer",
                        "description": "Cantidad total de bultos que ampara el documento.",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "TipoBultos": {
                        "type": "array",
                        "maxItems": 10,
                        "CodTpoBultos": {
                            "type": "integer",
                            "description": "Código según tabla \"Tipos de Bultos\" de aduana",
                            "minimum": 0,
                            "exclusiveMinimum": true
                        },
                        "CantBultos": {
                            "type": "integer",
                            "description": "Cantidad de Bultos",
                            "minimum": 0,
                            "exclusiveMinimum": true
                        },
                        "Marcas": {
                            "type": "string",
                            "description": "Identificación de marcas, cuando es distinto de contenedor",
                            "maxLength": 255
                        },
                        "IdContainer": {
                            "type": "string",
                            "description": "Se utiliza cuando el tipo de bulto es contenedor",
                            "maxLength": 25
                        },
                        "Sello": {
                            "type": "string",
                            "description": "Sello contenedor. Con digito verificador",
                            "maxLength": 20
                        },
                        "EmisorSello": {
                            "type": "string",
                            "description": "Nombre emisor sello",
                            "maxLength": 70
                        }
                    },
                    "MntFlete": {
                        "type": "number",
                        "description": "Monto del flete según moneda de venta - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                        "maximum": 1000000000000000000,
                        "minimum": 1,
                        "exclusiveMinimum": false,
                        "exclusiveMaximum": false
                    },
                    "MntSeguro": {
                        "type": "number",
                        "description": "Monto del seguro , según moneda de venta - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                        "maximum": 1000000000000000000,
                        "minimum": 1,
                        "exclusiveMinimum": false,
                        "exclusiveMaximum": false
                    },
                    "CodPaisRecep": {
                        "type": "integer",
                        "description": "Código del país del receptor extranjero de la mercadería,\nsegún tabla Países aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    },
                    "CodPaisDestin": {
                        "type": "integer",
                        "description": "Código del país de destino extranjero de la mercadería,\nsegún tabla Países aduana",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    }
                }
            },
            "Totales": {
                "type": "object",
                "description": "Montos Totales del DTE",
                "MntNeto": {
                    "type": "integer",
                    "description": "Monto Neto del DTE - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "MntExe": {
                    "type": "integer",
                    "description": "Monto Exento del DTE - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "MntBase": {
                    "type": "integer",
                    "description": "Monto Base Faenamiento Carne - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "MntMargenCom": {
                    "type": "integer",
                    "description": "Monto Base de Márgenes de Comercialización. Monto informado - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "TasaIVA": {
                    "type": "number",
                    "description": "Tasa de IVA - Monto de Porcentaje ( 3 y 2)",
                    "maximum": 99999,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "IVA": {
                    "type": "integer",
                    "description": "Monto de IVA del DTE - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "IVAProp": {
                    "type": "integer",
                    "description": "Monto del IVA propio - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "IVATerc": {
                    "type": "integer",
                    "description": "Monto del IVA de Terceros - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "ImptoReten": {
                    "type": "array",
                    "maxItems": 20,
                    "TipoImp": {
                        "type": "string",
                        "description": "Tipo de Impuesto o Retencion Adicional - Tipo de Impuesto o Retencion Adicional de los DTE",
                        "enum": [
                            "14",
                            "15",
                            "16",
                            "17",
                            "18",
                            "19",
                            "23",
                            "24",
                            "25",
                            "26",
                            "27",
                            "28",
                            "30",
                            "31",
                            "32",
                            "33",
                            "34",
                            "35",
                            "36",
                            "37",
                            "38",
                            "39",
                            "40",
                            "41",
                            "44",
                            "45",
                            "46",
                            "47",
                            "48",
                            "49",
                            "50",
                            "51",
                            "52",
                            "53",
                            "54",
                            "55",
                            "271",
                            "301",
                            "321",
                            "331",
                            "341",
                            "361",
                            "371",
                            "481"
                        ],
                        "maxLength": 3
                    },
                    "TasaImp": {
                        "description": "Tasa de Impuesto o Retencion",
                        "maximum": 10000,
                        "exclusiveMaximum": false,
                        "allOf": [
                            {
                                "$ref": "#/definitions/PctType"
                            }
                        ]
                    },
                    "MontoImp": {
                        "type": "integer",
                        "description": "Monto del Impuesto o Retencion - Monto de Impuesto - 18 digitos",
                        "minimum": 0,
                        "exclusiveMinimum": true
                    }
                },
                "IVANoRet": {
                    "type": "integer",
                    "description": "IVA No Retenido - Monto de Impuesto - 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": true
                },
                "CredEC": {
                    "type": "integer",
                    "description": "Credito Especial Empresas Constructoras - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "GrntDep": {
                    "type": "integer",
                    "description": "Garantia por Deposito de Envases o Embalajes - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "Comisiones": {
                    "type": "object",
                    "description": "Comisiones y otros cargos es obligatoria para Liquidaciones Factura",
                    "ValComNeto": {
                        "type": "integer",
                        "description": "Valor Neto Comisiones y Otros Cargos - Monto de 18 digitos",
                        "minimum": 0,
                        "exclusiveMinimum": false
                    },
                    "ValComExe": {
                        "type": "integer",
                        "description": "Val. Comis. y Otros Cargos no Afectos o Exentos - Monto de 18 digitos",
                        "minimum": 0,
                        "exclusiveMinimum": false
                    },
                    "ValComIVA": {
                        "type": "integer",
                        "description": "Valor IVA Comisiones y Otros Cargos - Monto de 18 digitos",
                        "minimum": 0,
                        "exclusiveMinimum": false
                    }
                },
                "MntTotal": {
                    "type": "integer",
                    "description": "Monto Total del DTE - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "MontoNF": {
                    "type": "integer",
                    "description": "Monto No Facturable - Corresponde a Bienes o Servicios Facturados Previamente - Monto de 18 digitos - Positivo o Negativo"
                },
                "MontoPeriodo": {
                    "type": "integer",
                    "description": "Total de Ventas o Servicios del Periodo - Monto de 18 digitos - Positivo o Negativo"
                },
                "SaldoAnterior": {
                    "type": "integer",
                    "description": "Saldo Anterior - Puede ser Negativo o Positivo - Monto de 18 digitos - Positivo o Negativo"
                },
                "VlrPagar": {
                    "type": "integer",
                    "description": "Valor a Pagar Total del documento - Monto de 18 digitos - Positivo o Negativo"
                }
            },
            "OtraMoneda": {
                "type": "object",
                "description": "Otra Moneda",
                "TpoMoneda": {
                    "type": "string",
                    "description": "Tipo Ottra moneda Tabla de Monedas de Aduanas - Tipos de Moneda de Aduana",
                    "enum": [
                        "BOLIVAR",
                        "BOLIVIANO",
                        "CHELIN",
                        "CORONA DIN",
                        "CORONA NOR",
                        "CORONA SC",
                        "CRUZEIRO REAL",
                        "DIRHAM",
                        "DOLAR AUST",
                        "DOLAR CAN",
                        "DOLAR HK",
                        "DOLAR NZ",
                        "DOLAR SIN",
                        "DOLAR TAI",
                        "DOLAR USA",
                        "DRACMA",
                        "ESCUDO",
                        "EURO",
                        "FLORIN",
                        "FRANCO BEL",
                        "FRANCO FR",
                        "FRANCO SZ",
                        "GUARANI",
                        "LIBRA EST",
                        "LIRA",
                        "MARCO AL",
                        "MARCO FIN",
                        "NUEVO SOL",
                        "OTRAS MONEDAS",
                        "PESETA",
                        "PESO",
                        "PESO CL",
                        "PESO COL",
                        "PESO MEX",
                        "PESO URUG",
                        "RAND",
                        "RENMINBI",
                        "RUPIA",
                        "SUCRE",
                        "YEN"
                    ],
                    "maxLength": 15
                },
                "TpoCambio": {
                    "type": "number",
                    "description": "Tipo de Cambio fijado por el Banco Central de Chile - Monto con 6 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 9999999999,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "MntNetoOtrMnda": {
                    "type": "number",
                    "description": "Monto Neto del DTE en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "MntExeOtrMnda": {
                    "type": "number",
                    "description": "Monto Exento del DTE en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "MntFaeCarneOtrMnda": {
                    "type": "number",
                    "description": "Monto Base Faenamiento Carne en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "MntMargComOtrMnda": {
                    "type": "number",
                    "description": "Monto Base de Márgenes de Comercialización. Monto informado - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "IVAOtrMnda": {
                    "type": "number",
                    "description": "Monto de IVA del DTE en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "ImpRetOtrMnda": {
                    "type": "array",
                    "maxItems": 20,
                    "TipoImpOtrMnda": {
                        "type": "string",
                        "description": "Tipo de Impuesto o Retencion Adicional - Tipo de Impuesto o Retencion Adicional de los DTE",
                        "enum": [
                            "14",
                            "15",
                            "16",
                            "17",
                            "18",
                            "19",
                            "23",
                            "24",
                            "25",
                            "26",
                            "27",
                            "28",
                            "30",
                            "31",
                            "32",
                            "33",
                            "34",
                            "35",
                            "36",
                            "37",
                            "38",
                            "39",
                            "40",
                            "41",
                            "44",
                            "45",
                            "46",
                            "47",
                            "48",
                            "49",
                            "50",
                            "51",
                            "52",
                            "53",
                            "54",
                            "55",
                            "271",
                            "301",
                            "321",
                            "331",
                            "341",
                            "361",
                            "371",
                            "481"
                        ],
                        "maxLength": 3
                    },
                    "TasaImpOtrMnda": {
                        "type": "number",
                        "description": "Tasa de Impuesto o Retencion - Monto de Porcentaje ( 3 y 2)",
                        "maximum": 99999,
                        "minimum": 1,
                        "exclusiveMinimum": false,
                        "exclusiveMaximum": false
                    },
                    "VlrImpOtrMnda": {
                        "type": "number",
                        "description": "Valor del impuesto o retención en otra moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                        "maximum": 1000000000000000000,
                        "minimum": 1,
                        "exclusiveMinimum": false,
                        "exclusiveMaximum": false
                    }
                },
                "IVANoRetOtrMnda": {
                    "type": "number",
                    "description": "IVA no retenido Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "MntTotOtrMnda": {
                    "type": "number",
                    "description": "Monto Total Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                }
            }
        },
        "Detalle": {
            "type": "array",
            "maxItems": 60,
            "minItems": 1,
            "NroLinDet": {
                "type": "integer",
                "description": "Numero Secuencial de Linea",
                "maximum": 99,
                "minimum": 0,
                "exclusiveMinimum": true,
                "exclusiveMaximum": false
            },
            "CdgItem": {
                "type": "array",
                "maxItems": 5,
                "TpoCodigo": {
                    "type": "string",
                    "description": "Tipo de Codificacion",
                    "maxLength": 10
                },
                "VlrCodigo": {
                    "type": "string",
                    "description": "Valor del Codigo de Item, para la Codificacion Particular",
                    "maxLength": 35
                }
            },
            "IndExe": {
                "type": "integer",
                "description": "Indicador de Exencion/Facturacion",
                "enum": [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ],
                "minimum": 0,
                "exclusiveMinimum": true
            },
            "Retenedor": {
                "type": "object",
                "description": "Sólo para transacciones realizadas por agentes retenedores",
                "IndAgente": {
                    "type": "string",
                    "description": "Indicador Agente Retenedor",
                    "enum": [
                        "R"
                    ],
                    "maxLength": 1
                },
                "MntBaseFaena": {
                    "type": "integer",
                    "description": "Monto Base Faenamiento - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "MntMargComer": {
                    "type": "integer",
                    "description": "Márgenes de Comercialización - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                },
                "PrcConsFinal": {
                    "type": "integer",
                    "description": "Precio Unitario Neto Consumidor Final - Monto de 18 digitos",
                    "minimum": 0,
                    "exclusiveMinimum": false
                }
            },
            "NmbItem": {
                "type": "string",
                "description": "Nombre del Item",
                "maxLength": 80
            },
            "DscItem": {
                "type": "string",
                "description": "Descripcion del Item",
                "maxLength": 1000
            },
            "QtyRef": {
                "type": "number",
                "description": "Cantidad para la Unidad de Medida de Referencia - Monto con 12 Digitos de Cuerpo y 6 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "UnmdRef": {
                "type": "string",
                "description": "Unidad de Medida de Referencia",
                "maxLength": 4
            },
            "PrcRef": {
                "type": "number",
                "description": "Precio Unitario de Referencia para Unidad de Referencia - Monto con 12 Digitos de Cuerpo y 6 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "QtyItem": {
                "type": "number",
                "description": "Cantidad del Item - Monto con 12 Digitos de Cuerpo y 6 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "Subcantidad": {
                "type": "array",
                "maxItems": 5,
                "SubQty": {
                    "type": "number",
                    "description": "Cantidad Distribuida - Monto con 12 Digitos de Cuerpo y 6 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "SubCod": {
                    "type": "string",
                    "description": "Codigo Descriptivo de la Subcantidad",
                    "maxLength": 35
                }
            },
            "FchElabor": {
                "type": "string",
                "description": "Fecha Elaboracion del Item - Fecha entre 2000-01-01 y 2050-12-31"
            },
            "FchVencim": {
                "type": "string",
                "description": "Fecha Vencimiento del Item - Fecha entre 2000-01-01 y 2050-12-31"
            },
            "UnmdItem": {
                "type": "string",
                "description": "Unidad de Medida",
                "maxLength": 4
            },
            "PrcItem": {
                "type": "number",
                "description": "Precio Unitario del Item en Pesos - Monto con 12 Digitos de Cuerpo y 6 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "OtrMnda": {
                "type": "object",
                "description": "Precio del Item en Otra Moneda",
                "PrcOtrMon": {
                    "type": "number",
                    "description": "Precio Unitario en Otra Moneda - Monto con 12 Digitos de Cuerpo y 6 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "Moneda": {
                    "type": "string",
                    "description": "Codigo de Otra Moneda (Usar Codigos de Moneda del Banco Central)",
                    "maxLength": 3
                },
                "FctConv": {
                    "type": "number",
                    "description": "Factor para Conversion a Pesos - Monto con 6 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 9999999999,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "DctoOtrMnda": {
                    "type": "number",
                    "description": "Descuento en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "RecargoOtrMnda": {
                    "type": "number",
                    "description": "Recargo en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                },
                "MontoItemOtrMnda": {
                    "type": "number",
                    "description": "Valor por línea de detalle en Otra Moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                }
            },
            "DescuentoPct": {
                "type": "number",
                "description": "Porcentaje de Descuento - Monto de Porcentaje ( 3 y 2)",
                "maximum": 99999,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "DescuentoMonto": {
                "type": "integer",
                "description": "Monto de Descuento - Monto de Impuesto - 18 digitos",
                "minimum": 0,
                "exclusiveMinimum": true
            },
            "SubDscto": {
                "type": "array",
                "maxItems": 5,
                "TipoDscto": {
                    "type": "string",
                    "description": "Tipo de SubDescuento - Unidad en que se expresa el Valor",
                    "enum": [
                        "%",
                        "$"
                    ],
                    "maxLength": 1,
                    "minLength": 1
                },
                "ValorDscto": {
                    "type": "number",
                    "description": "Valor del SubDescuento - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                }
            },
            "RecargoPct": {
                "description": "Porcentaje de Recargo",
                "maximum": 99999,
                "exclusiveMaximum": false,
                "allOf": [
                    {
                        "$ref": "#/definitions/PctType"
                    }
                ]
            },
            "RecargoMonto": {
                "type": "integer",
                "description": "Monto de Recargo - Monto de Impuesto - 18 digitos",
                "minimum": 0,
                "exclusiveMinimum": true
            },
            "SubRecargo": {
                "type": "array",
                "maxItems": 5,
                "TipoRecargo": {
                    "type": "string",
                    "description": "Tipo de SubRecargo - Unidad en que se expresa el Valor",
                    "enum": [
                        "%",
                        "$"
                    ],
                    "maxLength": 1,
                    "minLength": 1
                },
                "ValorRecargo": {
                    "type": "number",
                    "description": "Valor de SubRecargo - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                    "maximum": 1000000000000000000,
                    "minimum": 1,
                    "exclusiveMinimum": false,
                    "exclusiveMaximum": false
                }
            },
            "CodImpAdic": {
                "type": "array",
                "maxItems": 2,
                "enum": [
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "50",
                    "51",
                    "52",
                    "53",
                    "54",
                    "55",
                    "271",
                    "301",
                    "321",
                    "331",
                    "341",
                    "361",
                    "371",
                    "481"
                ],
                "maxLength": 3
            },
            "MontoItem": {
                "type": "integer",
                "description": "Monto por Linea de Detalle. Corresponde al Monto Neto, a menos que MntBruto Indique lo Contrario - Monto de 18 digitos",
                "minimum": 0,
                "exclusiveMinimum": false
            }
        },
        /* "SubTotInfo": {
            "type": "array",
            "maxItems": 20,
            "NroSTI": {
                "type": "integer",
                "description": "Número de Subtotal",
                "maximum": 99,
                "minimum": 0,
                "exclusiveMinimum": true,
                "exclusiveMaximum": false
            },
            "GlosaSTI": {
                "type": "string",
                "description": "Glosa",
                "maxLength": 40
            },
            "OrdenSTI": {
                "type": "integer",
                "description": "Ubicación para Impresión",
                "maximum": 99,
                "minimum": 0,
                "exclusiveMinimum": true,
                "exclusiveMaximum": false
            },
            "SubTotNetoSTI": {
                "type": "number",
                "description": "Valor Neto del Subtotal - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "SubTotIVASTI": {
                "type": "number",
                "description": "Valor del IVA del Subtotal - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "SubTotAdicSTI": {
                "type": "number",
                "description": "Valor de los Impuestos adicionales o específicos del Subtotal - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "SubTotExeSTI": {
                "type": "number",
                "description": "Valor no Afecto o Exento del Subtotal - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "ValSubtotSTI": {
                "type": "number",
                "description": "Valor de la línea de subtotal - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "LineasDeta": {
                "type": "integer",
                "description": "TABLA de Líneas de Detalle que se agrupan en el Subtotal",
                "minimum": 0,
                "exclusiveMinimum": true
            }
        }, */
        "DscRcgGlobal": {
            "type": "array",
            "maxItems": 20,
            "NroLinDR": {
                "type": "integer",
                "description": "Numero Secuencial de Linea",
                "minimum": 0,
                "exclusiveMinimum": true
            },
            "TpoMov": {
                "type": "string",
                "description": "Tipo de Movimiento",
                "enum": [
                    "D",
                    "R"
                ],
                "maxLength": 1,
                "minLength": 1
            },
            "GlosaDR": {
                "type": "string",
                "description": "Descripcion del Descuento o Recargo",
                "maxLength": 45
            },
            "TpoValor": {
                "type": "string",
                "description": "Unidad en que se Expresa el Valor - Unidad en que se expresa el Valor",
                "enum": [
                    "%",
                    "$"
                ],
                "maxLength": 1,
                "minLength": 1
            },
            "ValorDR": {
                "type": "number",
                "description": "Valor del Descuento o Recargo - Monto con 16 Digitos de Cuerpo y 2 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "ValorDROtrMnda": {
                "type": "number",
                "description": "Valor en otra moneda - Monto con 14 Digitos de Cuerpo y 4 Decimales",
                "maximum": 1000000000000000000,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "IndExeDR": {
                "type": "integer",
                "description": "Indica si el D/R es No Afecto o No Facturable",
                "enum": [
                    1,
                    2
                ],
                "minimum": 0,
                "exclusiveMinimum": true
            }
        },
        "Referencia": {
            "type": "array",
            "maxItems": 40,
            "NroLinRef": {
                "type": "integer",
                "description": "Numero Secuencial de Linea de Referencia",
                "maximum": 99,
                "minimum": 0,
                "exclusiveMinimum": true,
                "exclusiveMaximum": false
            },
            "TpoDocRef": {
                "type": "string",
                "description": "Tipo de Documento de Referencia",
                "maxLength": 3,
                "minLength": 1
            },
            "IndGlobal": {
                "type": "integer",
                "description": "Indica que se esta Referenciando un Conjunto de Documentos",
                "enum": [
                    1
                ],
                "minimum": 0,
                "exclusiveMinimum": false
            },
            "FolioRef": {
                "type": "string",
                "description": "Folio del Documento de Referencia - Folio de Referencia - 18 digitos (incluye el cero)",
                "maxLength": 18,
                "minLength": 1
            },
            "RUTOtr": {
                "type": "string",
                "description": "RUT Otro Contribuyente - Rol Unico Tributario (99..99-X)",
                "maxLength": 10,
                "minLength": 3,
                "pattern": "[0-9]+-([0-9]|K)"
            },
            "FchRef": {
                "type": "string",
                "description": "Fecha de la Referencia - Fecha entre 2000-01-01 y 2050-12-31"
            },
            "CodRef": {
                "type": "integer",
                "description": "Tipo de Uso de la Referencia",
                "enum": [
                    1,
                    2,
                    3
                ],
                "minimum": 0,
                "exclusiveMinimum": true
            },
            "RazonRef": {
                "type": "string",
                "description": "Razon Explicita por la que se Referencia el Documento",
                "maxLength": 90
            }
        },
        /* "Comisiones": {
            "type": "array",
            "maxItems": 20,
            "NroLinCom": {
                "type": "integer",
                "description": "Numero Secuencial de Linea",
                "maximum": 20,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "TipoMovim": {
                "type": "string",
                "description": "C (comisión) u O (otros cargos)",
                "enum": [
                    "C",
                    "O"
                ],
                "minLength": 1
            },
            "Glosa": {
                "type": "string",
                "description": "Especificación de la comisión u otro cargo",
                "maxLength": 60,
                "minLength": 1
            },
            "TasaComision": {
                "type": "number",
                "description": "Valor porcentual de la comisión u otro cargo - Monto de Porcentaje ( 3 y 2)",
                "maximum": 99999,
                "minimum": 1,
                "exclusiveMinimum": false,
                "exclusiveMaximum": false
            },
            "ValComNeto": {
                "type": "integer",
                "description": "Valor Neto Comisiones y Otros Cargos - Monto de 18 digitos",
                "minimum": 0,
                "exclusiveMinimum": false
            },
            "ValComExe": {
                "type": "integer",
                "description": "Val. Comis. y Otros Cargos no Afectos o Exentos - Monto de 18 digitos",
                "minimum": 0,
                "exclusiveMinimum": false
            },
            "ValComIVA": {
                "type": "integer",
                "description": "Valor IVA Comisiones y Otros Cargos - Monto de 18 digitos",
                "minimum": 0,
                "exclusiveMinimum": false
            }
        } */
    }
}

export default schema;